export const renameKey = (
  data: Record<string, string>,
  oldKey: string,
  newKey: string
) => {
  const newObject = {}
  delete Object.assign(newObject, data, { [newKey]: data[oldKey] })[oldKey]
  return newObject
}
